import router from '@/router';
import { $deleteFromArray, $handleError, $updateOrAdd, isJsonString } from '@/utils';
import taskManagerService from '@TaskManager/service/TaskManager.service';
import Vue from 'vue';

export const TASK_MANAGER = {
  namespaced: true,
  state: {
    entries: [],
    entriesByUser: [],
    loading: false,
    updateLoading: false,
    loadingType: false,
    currentTaskType: null,
  },
  getters: {
    GET_ENTRIES(state) {
      return state.entries;
    },
    GET_ENTRIES_BY_USER(state) {
      return state.entriesByUser;
    },
    GET_LOADING(state) {
      return state.loading;
    },
    GET_LOADING_TYPE(state) {
      return state.loadingType;
    },
    GET_UPDATE_LOADING(state) {
      return state.updateLoading;
    },
    GET_CURRENT_TASK_TYPE(state) {
      return state.currentTaskType;
    }
  },
  mutations: {
    SET_ENTRIES(state, value) {
      state.entries = value;
    },
    SET_ENTRIES_BY_USER(state, value) {
      state.entriesByUser = value;
    },
    SET_LOADING(state, value) {
      state.loading = value;
    },
    SET_LOADING_TYPE(state, value) {
      state.loadingType = value;
    },
    SET_UPDATE_LOADING(state, value) {
      state.updateLoading = value;
    },
    SET_CURRENT_TASK_TYPE(state, value) {
      state.currentTaskType = value;
    }
  },
  actions: {
    GET({ commit }) {
      commit('SET_LOADING', true);
      let facilityId = router.currentRoute.params.id;
      return taskManagerService
        .getByFacilityId(facilityId)
        .then((res) => {
          commit('SET_ENTRIES', res.data.map(mapType));
        })
        .catch((err) => {
          $handleError(err);
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    },

    GET_BY_USER({ commit }) {      
      let facilityId = router.currentRoute.params.id;
      if (!facilityId) {
        commit('SET_ENTRIES_BY_USER', []);
        return;
      }

      commit('SET_LOADING', true);

      return taskManagerService
        .getByUser({ facilityId })
        .then((res) => {
          commit('SET_ENTRIES_BY_USER', res.data.map(mapType));
        })
        .catch((err) => {
          $handleError(err);
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    },

    GET_BY_ID({ commit }, id) {
      commit('SET_LOADING_TYPE', true);
      return new Promise((resolve, reject) => {
        taskManagerService
          .getById(id)
          .then((res) => {
            resolve(mapType(res.data));
          })
          .catch((err) => {
            reject(err);
          })
          .finally(() => {
            commit('SET_LOADING_TYPE', false);
          });
      });
    },
    UPDATE({ state, commit }, data) {
      commit('SET_UPDATE_LOADING', true);
      data.groupBy = JSON.stringify(data.groupBy || []);
      return new Promise((resolve, reject) => {
        taskManagerService
          .update(data)
          .then((res) => {
            $updateOrAdd(state.entries, mapType(res.data));
            Vue.prototype.$dialog.notify.success(
              `Task Type Data Successfully ${data.id ? 'Updated' : 'Added'}.`,
            );
            resolve(res.data);
          })
          .catch((err) => {
            $handleError(err);
            reject();
          })
          .finally(() => {
            commit('SET_UPDATE_LOADING', false);
          });
      });
    },
    DELETE({ state, commit }, id) {
      return taskManagerService
        .del(id)
        .then(() => {
          $deleteFromArray(state.entries, id);
          commit('SET_TOTAL', --state.total);
          Vue.prototype.$dialog.notify.success('Deleted Successfully', {
            position: 'top-right',
            timeout: 3000,
          });
        })
        .catch((err) => {
          $handleError(err);
        });
    },
    DELETE_SECTION({ state, commit },{sectionId,typeId}) {
      commit('SET_UPDATE_LOADING', true);
      return new Promise((resolve, reject) => {
        taskManagerService
        .delSection(sectionId)
        .then(() => {
          var taskType=state.entries.find(e=>e.id==typeId);
          
          $deleteFromArray(taskType.sections,sectionId);
          $updateOrAdd(state.entries,taskType);
          Vue.prototype.$dialog.notify.success('Deleted Successfully', {
            position: 'top-right',
            timeout: 3000,
          });
          resolve();
        })
        .catch((err) => {
          $handleError(err);
          reject();
        }) .finally(() => {
          commit('SET_UPDATE_LOADING', false);
        });

       
      });

     
    },
    SECTION_IS_USED({   commit }, sectionId) {
      commit('SET_UPDATE_LOADING', true);
      
      return new Promise((resolve, reject) => {
        taskManagerService
          .sectionIsUsed(sectionId)
          .then((res) => {
           
            resolve(res.data);
          })
          .catch((err) => {
            $handleError(err);
            reject();
          })
          .finally(() => {
            commit('SET_UPDATE_LOADING', false);
          });
      });
    }
  },
};

function mapType(data) {
  data.groupBy = data.groupBy  &&isJsonString(data.groupBy)? JSON.parse(data.groupBy) : [];
  if (data.statuses.length > 0) {
    data.statuses.sort((a, b) => a.order - b.order);
  }
 
  return data;
}
